// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./themes/inspinia/font-awesome/css/all.min.css
// module id = 1305
// module chunks = 0